import 'assets/css/modal.css';
import 'styles/custom.css';
import * as React from 'react';
import { StandardScreen } from 'components/Layout/ScreenWrapper.jsx';
import {
    StandardSearchBox,
    StandardDropdown,
    StandardTextField,
    StandardButton,
    StatusMessage,
    StandardText,
    TextFieldWithTooltip,
} from '../components/Layout/FormComponents.jsx';
import { getCurrentMaxJobs, updateMaxJobs, getRegionNames, getCurrentMaxJobsPerType, deleteMaxJobsPerType, updateMaxJobsPerType, getRequestTypeOptions} from "../components/Requests/Requests";
import { StandardTable } from 'components/Layout/TableComponents.jsx';
import { StandardTableHeader } from 'components/Layout/TableComponents.jsx';
import { StandardTableBody } from 'components/Layout/TableComponents.jsx';
import { StandardTableRow } from 'components/Layout/TableComponents.jsx';
import { StandardTableCell } from 'components/Layout/TableComponents.jsx';
import { PageLayout } from 'components/Layout/BaseComponents.jsx';
import theme from '../styles/theme.js';

class UpdateMaxJobs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            error: "",
            errorPerType: "",
            spHostUrl: "",
            regionNameChosen: "",
            regionNames: "",
            batchSize: "",
            message: "",
            messagePerType: "",
            maxJobs: "",
            currentMaxJobs: "",
            regions: "",
            requestType: "",
            spHostUrlPerType: "",
            regionNameChosenPerType: "",
            messageList: "",
            maxJobCount: "",
            enumValue: "",
            requestTypeOptions: "",
            taskRequestType: "",
            responseMessage: "",
            reason: "",
            reasonPerType: "",
            globalMaxJobsPerType: "",
        }
    }

    componentDidMount() {
        this.initializeSettings();
    }

    initializeSettings() {
        this.getRegionNames();
    }

    renderMaxJobsTable() {
        const {loading, messagePerType, responseMessage, spHostUrlPerType, regionNameChosenPerType} = this.state;
        
        // Don't show anything if no search has been performed yet
        if (!spHostUrlPerType || !regionNameChosenPerType) {
            return null;
        }

        if (loading) {
            return <StatusMessage>Loading...</StatusMessage>;
        }
        
        // If we have data, show the table
        if (messagePerType && messagePerType.length > 0) {
            return (
                <StandardTable>
                    <StandardTableHeader
                        columns = {['SPHostUrl', 'TaskRequestType', 'MaxJobs', 'Actions']}
                    ></StandardTableHeader>

                    <StandardTableBody>
                        {messagePerType.map((outputMessage, index) => (
                            <StandardTableRow key ={index} index = {index}>
                                <StandardTableCell>{outputMessage.spHostUrl}</StandardTableCell>
                                <StandardTableCell>{outputMessage.enumValue}</StandardTableCell>
                                <StandardTableCell>{outputMessage.maxJobCount}</StandardTableCell>
                                <StandardTableCell>
                                    <StandardButton
                                        text = "Delete"
                                        size = "small"
                                        onClick = {() => this.deleteMaxJobPerType(outputMessage.spHostUrl, outputMessage.enumValue)}
                                        style = {{
                                            backgroundColor: '#d32f2f',
                                            color: 'white',
                                            border: 'none',
                                            padding: '5px 10px',
                                            cursor: 'pointer'
                                        }}
                                    >
                                    </StandardButton>
                                </StandardTableCell>
                            </StandardTableRow>
                        ))}
                    </StandardTableBody>
                </StandardTable>
            );
        }

        return null;
    }

    async getRegionNames() {
        this.setState({ loading: true })
        let response = await getRegionNames(this.props.accessToken);
        if (response.status === 200) {
            let data = await response.json();
            this.setState({
                loading: false,
                regionNames: data.map(item =>
                    ({ key: item, text: item })),
            });
        } else {
            this.setState({ loading: false, error: "Something went wrong", message: "" });
        };
    }

    async getRequestTypeOptions() {
        let requestBody = {
            SPHostUrl: this.state.spHostUrlPerType,
            RegionName: this.state.regionNameChosenPerType,
        };
    
        try {
            let response = await getRequestTypeOptions(this.props.accessToken, requestBody);
            if (response.ok) {
                let data = await response.json();
                this.setState({
                    loading: false,
                    requestTypeOptions: data.map(item => ({ value: item.enum, text: item.enum + ' - ' + item.enumValue })),
                });
            } else {
                console.error('Failed to fetch request type options:', response.statusText);
                this.setState({ loading: false });
            }
        } catch (error) {
            console.error('Error fetching request type options:', error);
            this.setState({ loading: false });
        }
    }

    onSelectRegionName = (event, item) => {
        this.setState({ regionNameChosen: item.key });
    };

    onSelectRegionNamePerType = (event, item) => {
        this.setState({ regionNameChosenPerType: item.key });
    };

    async getCurrentMaxJobs() {
        this.setState({ 
            loading: true,
            error: "",
            message: "",
            currentMaxJobs: ""
        });
        
        let requestBody = {
            SPHostUrl: this.state.spHostUrl,
            RegionName: this.state.regionNameChosen,
        };
        
        try {
            let response = await getCurrentMaxJobs(this.props.accessToken, requestBody);
            let data = await response.json();
            
            if (response.status === 200) {
                this.setState({ 
                    loading: false, 
                    currentMaxJobs: data.maxJobs, 
                    message: data.message 
                });
            } else if(response.status === 404) {
                this.setState({ 
                    loading: false, 
                    message: data.message || "No MaxJobs configuration found for this SPHostUrl", 
                    currentMaxJobs: "" 
                });
            } else {
                this.setState({ 
                    loading: false, 
                    error: data.message || "Failed to fetch MaxJobs configuration"
                });
            }
        } catch (error) {
            this.setState({ 
                loading: false, 
                error: "Network error occurred while fetching MaxJobs configuration"
            });
        }
    }

    async getCurrentMaxJobsPerType() {
        this.setState({ 
            loading: true,
            errorPerType: "",
            responseMessage: "",
            messagePerType: []
        });
        
        let requestBody = {
            SPHostUrl: this.state.spHostUrlPerType,
            RegionName: this.state.regionNameChosenPerType,
        };
        
        try {
            let response = await getCurrentMaxJobsPerType(this.props.accessToken, requestBody);
            let data = await response.json();
            
            if (response.status === 200) {
                this.setState({ 
                    loading: false, 
                    messagePerType: data.messagePerType || [],
                    responseMessage: "", 
                    errorPerType: (!data.messagePerType || data.messagePerType.length === 0) ? "No MaxJobs configured for this SPHostUrl and environment" : ""
                });
            } else {
                this.setState({ 
                    loading: false, 
                    errorPerType: "Failed to fetch MaxJobs configuration",
                    messagePerType: [],
                    responseMessage: ""
                });
            }
        } catch (error) {
            this.setState({ 
                loading: false, 
                errorPerType: "Network error occurred while fetching MaxJobs configuration",
                messagePerType: [],
                responseMessage: ""
            });
        }
    }

    async getGlobalMaxJobsPerType(){
        let requestBody = {
            SPHostUrl: this.state.spHostUrlPerType,
            RegionName: this.state.regionNameChosenPerType
        };

        try{
            let response = await getCurrentMaxJobs(this.props.accessToken, requestBody);
            let data = await response.json();

            if(response.status === 200){
                this.setState({
                    globalMaxJobsPerType: data.maxJobs
                });
            } else {
                this.setState({
                    globalMaxJobsPerType: "" 
                });
            }
        } catch (error){
            this.setState({
                globalMaxJobsPerType: ""
            });
        }
    }

    async updateMaxJobs() {
        this.setState({ 
            loading: true,
            error: "",
            message: ""
        });
        
        let requestBody = {
            SPHostUrl: this.state.spHostUrl,
            RegionName: this.state.regionNameChosen,
            MaxJobs: this.state.maxJobs,
            Reason: this.state.reason
        };
        let response = await updateMaxJobs(this.props.accessToken, requestBody);
        let data = await response.json();
        if (response.status === 200) {
            this.setState({ loading: false, maxJobs: data.maxJobs, message: data.message })
        }
        else if(response.status === 401){
            this.setState({loading: false, error: data.message, message: ""})
        }
        else {
            this.setState({ loading: false, error: "Something went wrong" });
        };
    }

    async updateMaxJobsPerType() {
        this.setState({ 
            loading: true,
            errorPerType: "",
            responseMessage: ""
        });
        
        let requestBody = {
            SPHostUrl: this.state.spHostUrlPerType,
            RegionName: this.state.regionNameChosenPerType,
            EnumValue: this.state.taskRequestType.value,
            MaxJobCount: this.state.maxJobCountPerType,
            Reason: this.state.reasonPerType
        };
        
        try {
            let response = await updateMaxJobsPerType(this.props.accessToken, requestBody);
            let data = await response.json();
            
            if (response.status === 200) {
                this.setState({ 
                    loading: false, 
                    responseMessage: data.message || "MaxJobs configuration updated successfully"
                });
                this.getCurrentMaxJobsPerType();
            }else if (response.status === 400) {
                this.setState({ 
                    loading: false, 
                    errorPerType: data.message 
                });
            } else {
                this.setState({ 
                    loading: false, 
                    errorPerType: data.message || "Failed to update MaxJobs configuration"
                });
            }
        } catch (error) {
            this.setState({ 
                loading: false, 
                errorPerType: "Network error occurred while updating MaxJobs configuration"
            });
        }
    }

    async deleteMaxJobPerType(spHostUrl, enumValue) {
        this.setState({ 
            loading: true,
            errorPerType: "",
            responseMessage: ""
        });

        const requestBody = {
            SPHostUrl: spHostUrl,
            EnumValue: enumValue,
            RegionName: this.state.regionNameChosenPerType,
        };
    
        try {
            let response = await deleteMaxJobsPerType(this.props.accessToken, requestBody);
            
            if (response.status === 200) {
                this.setState({ 
                    loading: false,
                    responseMessage: "MaxJobs configuration deleted successfully"
                });
                this.getCurrentMaxJobsPerType();
            } else {
                this.setState({ 
                    loading: false,
                    errorPerType: "Failed to delete MaxJobs configuration"
                });
            }
        } catch (error) {
            this.setState({ 
                loading: false,
                errorPerType: "Network error occurred while deleting MaxJobs configuration"
            });
        }
    }

    render() {
        return (
            <PageLayout>
                <StandardScreen
                    title="SPHost Max Jobs Configuration"
                    description="Configure the maximum number of jobs for a specific SPHostUrl"
                >
                    <StandardSearchBox
                        label="SPHostUrl"
                        placeholder="SPHostUrl to Configure"
                        value={this.state.spHostUrl}
                        onChange={newValue => this.setState({ spHostUrl: newValue })}
                    >
                    </StandardSearchBox>

                    <StandardDropdown
                        label="Environment"
                        selectedKey={this.state.regionNameChosen}
                        onChange={this.onSelectRegionName}
                        placeholder="Environment to Configure"
                        options={this.state.regionNames}
                    >
                    </StandardDropdown>

                    <StandardButton
                        text="Search"
                        onClick={() => this.getCurrentMaxJobs()}
                        disabled={this.state.spHostUrl.length === 0 || !this.state.regionNameChosen}
                    >
                    </StandardButton>

                    <StandardTextField
                        label="Reason"
                        placeholder="Provide a reason for making this change"
                        value={this.state.reason}
                        onChange={(event,newValue) => this.setState({ reason: newValue})}
                        disabled={this.state.spHostUrl.length === 0 || !this.state.regionNameChosen || !this.state.message}
                    >                        
                    </StandardTextField>

                    <TextFieldWithTooltip
                        label="Max Jobs"
                        type='number'
                        max='30'
                        placeholder="New MaxJobs for selected SPHostUrl"
                        onChange={(event, newValue) => this.setState({ maxJobs: newValue })}
                        disabled={this.state.spHostUrl.length === 0 || !this.state.regionNameChosen || !this.state.reason || this.state.message === ""}
                        
                        tooltipContent={
                            <StandardText
                                color={theme.colors.primary}
                                variant='small'
                            >
                                Recommended value is between 5-15. <br />
                                Maximum value is 30. <br />
                                Minimum value is 1*. <br />
                                <br />
                                <b><i>*It is possible to set value to 0 provided you are an admin.</i></b>
                            </StandardText>
                        }
                    ></TextFieldWithTooltip>

                    <StandardButton
                        text="Apply"
                        onClick={() => this.updateMaxJobs()}
                        disabled={this.state.spHostUrl.length === 0 || !this.state.regionNameChosen || !this.state.maxJobs || this.state.maxJobs > 30 || this.state.maxJobs < 0}
                    >
                    </StandardButton>

                    {this.state.error && (
                        <StatusMessage type="error">{this.state.error}</StatusMessage>
                    )}
                    {this.state.message && (
                        <StatusMessage type="success">{this.state.message}</StatusMessage>
                    )}
                </StandardScreen>

                <StandardScreen
                    title="Specific RequestType Max Jobs Configuration"
                    description="Configure the maximum number of jobs for a specific TaskRequestType and SPHostUrl"
                >
                    <StandardSearchBox
                        label="SpHostUrl"
                        placeholder="SPHostUrl to Configure"
                        value={this.state.spHostUrlPerType}
                        onChange={newValue => this.setState({ spHostUrlPerType: newValue })}
                    >
                    </StandardSearchBox>

                    <StandardDropdown
                        label="Environment"
                        placeholder="Environment to Configure"
                        selectedKey={this.state.regionNameChosenPerType}
                        onChange={this.onSelectRegionNamePerType}
                        options={this.state.regionNames}
                    ></StandardDropdown>

                    <StandardButton
                        text="Search"
                        onClick={() => {
                            this.getCurrentMaxJobsPerType()
                            this.getRequestTypeOptions()
                            this.getGlobalMaxJobsPerType()
                        }}
                        disabled={this.state.spHostUrlPerType.length === 0 || !this.state.regionNameChosenPerType}
                    >
                    </StandardButton>

                    <StandardDropdown
                        label="Type"
                        placeholder="Task Request Type"
                        options={this.state.requestTypeOptions}
                        onChange={(event, newValue) => this.setState({ taskRequestType: newValue })}
                        disabled={!this.state.requestTypeOptions}
                    >
                    </StandardDropdown>

                    <StandardTextField
                        label="Reason"
                        placeholder="Provide a reason for making this change"
                        value={this.state.reasonPerType}
                        onChange={(event,newValue) => this.setState({ reasonPerType: newValue})}
                        disabled={this.state.spHostUrlPerType.length === 0 || !this.state.regionNameChosenPerType || !this.state.taskRequestType}
                    >                        
                    </StandardTextField>

                    <StandardTextField
                        label="Max Jobs"
                        type='number'
                        max='30'
                        placeholder="New MaxJobs for selected SPHostUrl and Type"
                        onChange={(event, newValue) => this.setState({ maxJobCountPerType: newValue })}
                        disabled={this.state.spHostUrlPerType.length === 0 || !this.state.regionNameChosenPerType || !this.state.taskRequestType || !this.state.reasonPerType}
                    >
                    </StandardTextField>
                    
                    <StandardButton
                        text="Add/Update"
                        onClick={() => this.updateMaxJobsPerType()}
                        disabled={this.state.spHostUrlPerType.length === 0 || !this.state.regionNameChosenPerType || !this.state.taskRequestType || !this.state.maxJobCountPerType}
                    >
                    </StandardButton>
                        
                    {this.state.errorPerType && (
                        <StatusMessage type="error">{this.state.errorPerType}</StatusMessage>
                    )}

                    {this.state.responseMessage && (
                        <StatusMessage type="success">{this.state.responseMessage}</StatusMessage>
                    )}

                    {this.state.globalMaxJobsPerType != "" && (
                        <StandardText
                            color={theme.colors.primary}
                            variant='body'
                        >
                            Total MaxJobs for this SPHostUrl: <b>{this.state.globalMaxJobsPerType}</b>
                        </StandardText>
                    )}
                    {this.renderMaxJobsTable()}
                </StandardScreen>
            </PageLayout>
        );
    }
}
export default UpdateMaxJobs;